module.exports = __webpack_public_path__ + "img/wb.a6612ca0.png";